import { Form } from "antd";
import styled from "styled-components";
import { theme } from "../../../config";

export const FormItem = styled(Form.Item)`
  // height: 85px;
  // ${theme.formErrorMobileView}
  // @media ${theme.breakpoints.mobileAndTablet} {
  //   height: 70px;
  // }
`;

export const InputTitle = styled.p`
  margin-top: 18px;
  margin-bottom: 25px;
  height: 50px;
  color: ${theme.colors.dark};

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
    margin-top: 25px;
  }
`;

export const InputFile = styled.input`
  display: block;
`;

export const InputField = styled.div`
  margin-top: 20px;
`;

export const TextAreaTitle = styled.p`
  margin: 0;
  color: ${theme.colors.dark};

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
  }
`;

export const ErrorText = styled.div`
  margin-top 4px;
`;
